import React, { useState, useMemo, useEffect, useRef } from 'react';
import http from '../../Services/Http';
import RepsList from './components/RepsList';
import Loading from '../../Components/Loading';
import { useReveal } from '../../Components/Fx/useReveal';

interface Rep {
   id: string;
   name: string;
   party: string;
   state: string;
   district: string;
}

const RepresentativesPage = () => {
   const [searchTerm, setSearchTerm] = useState('');
   const [reps, setReps] = useState<Rep[]>([]);
   const scope = useRef<HTMLDivElement>(null);

   useEffect(() => {
      http.get('/reps').then(res => setReps(res.data));
   }, []);

   const filteredReps = useMemo(() => {
      const q = searchTerm.trim().toLowerCase();
      if (!q) return reps;
      return reps.filter(
         rep =>
            rep.name?.toLowerCase().includes(q) ||
            rep.state?.toLowerCase().includes(q) ||
            String(rep.district ?? '').toLowerCase().includes(q)
      );
   }, [searchTerm, reps]);

   useReveal(scope, [filteredReps]);

   if (!reps.length) return <Loading label="Convening Congress" />;

   return (
      <div ref={scope} className="page pb-6">
         <div className="mb-12 flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
            <div>
               <p className="eyebrow mb-3">Members</p>
               <p className="font-display text-4xl text-bone">
                  {filteredReps.length} <span className="text-bone-dim">of {reps.length}</span>
               </p>
            </div>
            <label className="relative block w-full md:max-w-sm">
               <span className="eyebrow">Search</span>
               <input
                  type="search"
                  placeholder="Name, state or district"
                  className="input"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
               />
            </label>
         </div>

         {filteredReps.length ? (
            <RepsList reps={filteredReps} />
         ) : (
            <p className="py-20 text-center text-bone-muted">No members match “{searchTerm}”.</p>
         )}
      </div>
   );
};

export default RepresentativesPage;
